export const ticketType = ["VIP Ticket", "Regular Ticket"];

export const errorMsg = {
  required: "This field is required",
  invalid: "Please provide a valid input",
  endAfterStart: "End date must be after start date",
  dimension: "Please provide an image with the right dimensions",
};
